import React, { useEffect, useState } from 'react';
import { Skeleton } from '@ace-clublabs/shared-component-library';
import { IGetManifest } from '@ace-clublabs/payment-types';
import { IGetAdyenSession } from '../api/contracts';
import EmbedAdyenPayment from '../components/EmbedAdyenPayment/EmbedAdyenPayment';
import { isParentMessage, isOriginAllowed, setParentOrigin } from '../components/EmbedAdyenPayment/embedPostMessage';
import '../components/EmbedAdyenPayment/EmbedAdyenPayment.scss';

interface Props {
  manifestId: string;
  manifest: IGetManifest;
  adyenSession: IGetAdyenSession;
}

const EmbedAdyenPaymentRouter: React.FC<Props> = ({ manifestId, manifest, adyenSession }) => {
  const [parentReady, setParentReady] = useState(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!isOriginAllowed(event.origin)) return;
      if (!isParentMessage(event.data)) return;

      setParentOrigin(event.origin);

      if (event.data.type === 'START') {
        setParentReady(true);
      }
    };

    window.addEventListener('message', handleMessage);

    if (window.parent !== window) {
      const referrer = document.referrer;
      if (referrer) {
        try {
          const origin = new URL(referrer).origin;
          if (isOriginAllowed(origin)) {
            setParentOrigin(origin);
          }
        } catch {
          // invalid referrer
        }
      }
      window.parent.postMessage({ source: 'ace-payments-embed', type: 'READY', payload: {} }, '*');
    }

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="embed-router-wrapper">
      <div className={`embed-router-wrapper__form${parentReady ? ' embed-router-wrapper__form--visible' : ''}`}>
        <EmbedAdyenPayment manifestId={manifestId} manifest={manifest} adyenSession={adyenSession} />
      </div>
      <div className={`embed-router-wrapper__skeleton${parentReady ? ' embed-router-wrapper__skeleton--hidden' : ''}`}>
        <div className="embed-adyen-payment">
          <div className="embed-adyen-payment-skeleton">
            <Skeleton className="embed-adyen-payment-skeleton__title" variant="rectangular" height={32} />
            <Skeleton className="embed-adyen-payment-skeleton__subtitle" variant="rectangular" height={20} />
            <Skeleton className="embed-adyen-payment-skeleton__field--full" variant="rectangular" height={48} />
            <Skeleton className="embed-adyen-payment-skeleton__field--full" variant="rectangular" height={48} />
            <div className="embed-adyen-payment-skeleton__row">
              <Skeleton className="embed-adyen-payment-skeleton__field--third" variant="rectangular" height={48} />
              <Skeleton className="embed-adyen-payment-skeleton__field--third" variant="rectangular" height={48} />
              <Skeleton className="embed-adyen-payment-skeleton__field--third" variant="rectangular" height={48} />
            </div>
            <Skeleton className="embed-adyen-payment-skeleton__button" variant="rectangular" height={48} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmbedAdyenPaymentRouter;
